import React from "react";
import { Modal, Table, Badge } from "react-bootstrap";
import { useQuery } from "@apollo/client";
import { GET_BITACORA_BY_EMPRESA } from "../../utils/graphql_query";
import LoadingPage from "../base/LoadingPage";
import Errors from "../base/Errors";
import moment from "moment";
import _ from "lodash";

const ModalBitacora = ({ show, onHide, empresaId, empresaNombre }) => {
  const { loading, error, data } = useQuery(GET_BITACORA_BY_EMPRESA, {
    variables: { empresa_id: empresaId, limite: 100 },
    skip: !show,
  });

  const getAccionBadge = (accion) => {
    const variants = {
      crear: "success",
      modificar: "warning",
      eliminar: "danger",
    };
    return <Badge bg={variants[accion] || "secondary"}>{accion}</Badge>;
  };

  const formatDate = (fecha) => {
    return moment(fecha).format("DD/MM/YYYY HH:mm");
  };

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Bitácora - {empresaNombre}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        {loading && <LoadingPage />}
        {error && <Errors error={error} />}
        {data && _.size(data.getBitacoraByEmpresa) > 0 ? (
          <Table striped bordered hover size="sm">
            <thead>
              <tr>
                <th>Fecha/Hora</th>
                <th>Usuario</th>
                <th>Acción</th>
                <th>Entidad</th>
                <th>Campo</th>
                <th>Valor Anterior</th>
                <th>Valor Nuevo</th>
                <th>Descripción</th>
              </tr>
            </thead>
            <tbody>
              {_.map(data.getBitacoraByEmpresa, (item) => (
                <tr key={item.id}>
                  <td>{formatDate(item.fecha_hora)}</td>
                  <td>{item.usuario_nombre || "Sistema"}</td>
                  <td>{getAccionBadge(item.accion)}</td>
                  <td>{item.entidad}</td>
                  <td>{item.campo || "-"}</td>
                  <td>
                    <small>{item.valor_anterior || "-"}</small>
                  </td>
                  <td>
                    <small>{item.valor_nuevo || "-"}</small>
                  </td>
                  <td>
                    <small>{item.descripcion || "-"}</small>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          data && <p className="text-center text-muted">No hay registros en la bitácora</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalBitacora;
